

















/* Created- 15 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ArticleContributor, IArticle } from "../../../Models/ArticleModels/article";
@Component(
	{
		name: "ArticleContributors"
	})
export default class ArticleContributors extends Vue {
	@Prop() private value: IArticle;
	private newContributor: string = "";

	private remove(item: ArticleContributor) {
		if (this.value.removeContributor(item) === -1) {
			throw new Error("Unable to remove contributor as its not found.");
		}
	}
	private addContributor() {
		if (this.newContributor.length > 0) {
			this.value.addContributor(this.newContributor);
			this.newContributor = "";
		}
	}
}
